import { Component, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef, MatPaginator, MAT_DIALOG_DATA, PageEvent } from '@angular/material';
import { Router } from '@angular/router';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import swal from 'sweetalert2';
import { Filtro } from '../models/filtro';
import { Marca } from '../models/marca';
import { CarregandoService } from '../services/carregando.service';
import { GlobalService } from '../services/global.service';
import { MarcaService } from '../services/marca.service';
import { NotificacaoService } from '../services/notificacao.service';
import { UtilitarioService } from '../services/utilitario.service';
import { CadastrarMarcaComponent } from './cadastrar-marca/cadastrar-marca.component';
import { PaginatorService } from '../services/paginator.service';

declare const $: any;

@Component({
  selector: 'app-marca',
  templateUrl: './marca.component.html',
  styleUrls: ['./marca.component.scss']
})
export class MarcaComponent implements OnInit, OnDestroy {

  // variáveis
  marcas: Marca[] = [];
  marcasFiltrados: Marca[] = [];
  carregando = true;
  campoOrdenacao = 'nome';
  ordenarDesc = false;
  editavel = true;
  paginacao;
  listaDeItensPorPagina;
  itensPorPagina;
  filtroNome: Filtro = { Propriedade: 'nome', Valor: '' };
  filtros: Filtro[] = [this.filtroNome];
  public config: PerfectScrollbarConfigInterface = {};

  @ViewChild('paginator', { static: false }) paginator: MatPaginator;

  // construtor
  constructor(private marcaService: MarcaService, private utilitarioService: UtilitarioService,
    private router: Router, private globalService: GlobalService, private carregandoService: CarregandoService,
    private notificacaoService: NotificacaoService, public dialogRef: MatDialogRef<MarcaComponent>, private paginatorService: PaginatorService,
    @Inject(MAT_DIALOG_DATA) public data: any, public dialog: MatDialog) { }

  ngOnInit() {
    const pagination = this.paginatorService.consultarPaginacao();
    
    this.paginacao = pagination.paginacao;
    this.itensPorPagina = pagination.itensPorPagina;
    this.listaDeItensPorPagina = pagination.listaDeItensPorPagina;

    this.buscarMarcas();
  }

  ordena(campo) {
    if (campo) {
      this.campoOrdenacao = campo;
      this.ordenarDesc = !this.ordenarDesc;

      this.marcas = this.marcas.sort((a, b) => {
        const isAsc = !this.ordenarDesc;
        switch (this.campoOrdenacao) {
        case 'nome': return this.compare(a.descricao, b.descricao, isAsc);
        default: return 0;
        }
      });

      this.mudaDePagina({ length: this.paginator.length, pageIndex: this.paginator.pageIndex, pageSize: this.paginator.pageSize });
    }

    return false;
  }

  compare(a: number | string, b: number | string, isAsc: boolean) {
    if (typeof a === 'string') {
      a = a.toLowerCase();
    }

    if (typeof b === 'string') {
      b = b.toLowerCase();
    }

    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  filtra() {
    this.marcasFiltrados = this.marcas.filter(p => p.descricao.toLowerCase().
      includes(this.filtroNome.Valor.toString().toLowerCase()));

    if (this.itensPorPagina > this.listaDeItensPorPagina[this.listaDeItensPorPagina.length - 1]) {
      this.itensPorPagina = 10;
    }

    this.paginacao.total = this.marcasFiltrados.length;

    this.paginator.firstPage();

    this.mudaDePagina({ length: this.marcas.length, pageIndex: 0, pageSize: this.itensPorPagina });
  }

  buscarMarcas() {
    this.carregandoService.mostra('buscaMarcas');
    this.carregando = true;

    this.marcaService.consultarMarcas().subscribe((data: any) => {
      this.paginator.firstPage();
      this.marcas = data;

      if (this.itensPorPagina > this.listaDeItensPorPagina[this.listaDeItensPorPagina.length - 1]) {
        this.itensPorPagina = 10;
      }

      this.paginacao.total = this.marcas.length;

      this.mudaDePagina({ length: this.marcas.length, pageIndex: 0, pageSize: this.itensPorPagina });

      this.carregando = false;
      this.carregandoService.esconde('buscaMarcas');

    }, (erro) => {
      this.carregandoService.esconde('buscaMarcas');
      this.notificacaoService.erro(erro);
    });
  }

  novaMarca() {
    const largura = Number(($('body').width()));
    const dialogRef = this.dialog.open(CadastrarMarcaComponent, {
      width: largura > 730 ? '700px' : (($('body').width()).toString() + 'px'),
      data: { marca: new Marca() },
      panelClass: 'modal-card'
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.buscarMarcas();
      }
    });
  }

  editarMarca(marca: Marca) {
    const largura = Number(($('body').width()));
    const marcaParaEditar = new Marca();
    Object.assign(marcaParaEditar, marca);

    const dialogRef = this.dialog.open(CadastrarMarcaComponent, {
      width: largura > 730 ? '700px' : (($('body').width()).toString() + 'px'),
      data: { marca: marcaParaEditar },
      panelClass: 'modal-card'
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.buscarMarcas();
      }
    });
  }

  excluirMarca(marca: Marca) {
    swal({
      title: 'Atenção!!',
      text: 'Deseja realmente excluir a Marca?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonClass: 'btn btn-info',
      cancelButtonClass: 'btn btn-danger',
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não',
      buttonsStyling: false
    }).then((result) => {
      if (result.value) {
        this.carregandoService.mostra('excluiMarca');
        this.marcaService.excluir(marca.idMarca).subscribe(resp => {
          this.notificacaoService.sucesso('Marca excluída com sucesso!!!');
          this.carregandoService.esconde('excluiMarca');
          this.buscarMarcas();
        }, (erro) => {
          this.carregandoService.esconde('excluiMarca');
          this.notificacaoService.erro(erro);
        });
      }
    });
  }

  mudaDePagina(pageEvent: PageEvent) {
    if (this.itensPorPagina !== pageEvent.pageSize)
      this.paginatorService.salvaPaginacao(pageEvent.pageSize);

    this.itensPorPagina = pageEvent.pageSize;
    this.paginacao.paginaAtual = pageEvent.pageIndex + 1;

    this.marcasFiltrados = this.marcas.filter(p => p.descricao.toLowerCase().
      includes(this.filtroNome.Valor.toString().toLowerCase())).
      slice(pageEvent.pageIndex * pageEvent.pageSize,
        (pageEvent.pageIndex * pageEvent.pageSize) + pageEvent.pageSize);
  }

  ngOnDestroy(): void {}

  fechar() {
    this.dialogRef.close();
  }
}